
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
import { RouteConsts } from '@/routes/route';

// Components
import BasePage from '@/pages/BasePage.vue';
import { Prop } from 'vue-property-decorator';

// CMS
import { Docs } from '@/apis/cms';
import { AltContents } from '@/common/alternatives';

// utils
import orderBy from 'lodash/orderBy';

@Component
export default class DocsPage extends Mixins<BasePage>(BasePage) {
  @Prop({ default: '' })
  private initSelectedTab!: string;

  private selectedTab: string = '';

  private docs: Array<Docs> = [];
  private groupedDocs: Array<{ section: string; docs: Array<Docs> }> = [];

  private async getDocs() {
    // CMS API呼び出し
    const httpClient = await this.$cmsClient();
    const docs = await httpClient.docs
      .getDocs()
      .then(res => {
        const { data } = res;
        if (data.contents.length < 1) {
          return AltContents.DocsResponse.contents;
        }
        return orderBy(data.contents, 'order', 'asc');
      })
      .catch(() => {
        return AltContents.DocsResponse.contents;
      });
    return docs;
  }

  private setQueryTab(id: string) {
    this.$router.replace({ name: RouteConsts.DocsPage, query: { tab: id } });
  }

  private scrollToHash() {
    if (this.$route.hash !== '') {
      const refName = decodeURI(this.$route.hash);
      this.$scrollTo(refName, {
        duration: 500,
        offset: -60
      });
    }
  }

  async mounted() {
    //コンテンツ読み込みのバッファを取る
    setTimeout(this.scrollToHash, 500);
  }

  private async created() {
    this.store.showLoader();

    this.docs = await this.getDocs();

    const groupedDocs = this.docs.reduce((acc, doc) => {
      acc[doc.section[0]] = acc[doc.section[0]] || [];
      acc[doc.section[0]].push(doc);
      return acc;
    }, {} as { [key: string]: Array<Docs> });

    //連想配列型だと順序が保証されない可能性があるので、
    //配列形式で保持しておく

    //セクションをorderで並べた時に出てくる順番でユニーク化
    const sections = this.docs
      .map(elm => elm.section[0])
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    //セクション順に配列に格納
    for (const sec of sections) {
      this.groupedDocs.push({ section: sec, docs: groupedDocs[sec] });
    }

    if (this.$route.query.tab !== undefined) {
      this.selectedTab = String(this.$route.query.tab);
    } else if (this.docs.length > 0) {
      this.selectedTab = this.docs[0].id;
    }

    this.store.hideLoader();
  }
}
